import userApi from '@src/api/user'
import { getLastAppliedFeedFilter } from '@src/utilities/lastAppliedFeedFilter'
import { filterModelToQueryParams } from '@src/utilities/searchV2Filters'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const FILTER_QUERY_KEYS = [ 'space', 'categories', 'filter', 'concepts', 'include_archived', 'query', 'search', 'tags' ]

export async function useLastAppliedFeedFilter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (FILTER_QUERY_KEYS.some((key) => to.query[key] !== undefined)) {
    next()
    return
  }
  try {
    const { data: user } = await userApi.cached.getCurrentUser()
    const savedFilter = getLastAppliedFeedFilter(user.id)
    if (!savedFilter) {
      next()
      return
    }
    const modifiedNext = {
      ...to,
      name: to.name || undefined,
      query: { ...to.query, ...filterModelToQueryParams(savedFilter) }
    }
    next(modifiedNext)
  } catch {
    next()
  }
}
